export default "__VITE_ASSET__BxeDTvvh__"